import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);
  return (
    <div className="p-8 space-y-6" data-testid="audit-root">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Trace</div>
        <h1 className="font-heading text-4xl mt-1 tracking-tight">Audit Trail</h1>
        <p className="text-sm text-zinc-500 mt-1">Every mutation, forever. Sorted latest first.</p>
      </div>
      <div className="bg-white border border-zinc-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 text-[10px] uppercase tracking-widest text-zinc-500">
            <tr><th className="text-left p-4">When</th><th className="text-left p-4">Actor</th><th className="text-left p-4">Role</th><th className="text-left p-4">Entity</th><th className="text-left p-4">Action</th><th className="text-left p-4">Details</th></tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-zinc-100">
                <td className="p-3 text-xs tabular-nums text-zinc-500">{new Date(l.at).toLocaleString()}</td>
                <td className="p-3">{l.actor_email}</td>
                <td className="p-3 text-zinc-600">{l.actor_role}</td>
                <td className="p-3 font-mono text-xs">{l.entity}:{(l.entity_id || "").slice(0, 8)}</td>
                <td className="p-3 font-medium">{l.action}</td>
                <td className="p-3 text-xs text-zinc-600 max-w-xs truncate">{l.details ? JSON.stringify(l.details) : "—"}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-zinc-400">No audit logs.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
